const BASE_URL = `${window.location.protocol}//${window.location.host}`;

export async function getMe(userId) {
    const res = await fetch(`${BASE_URL}/api/administration/accessUser/${userId}`, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' }
    });

    if (!res.ok) {
        throw new Error(`Failed to get user: ${res.status}`);
    };

    return res.json();
}

export async function changePassword(currentPassword, newPassword, confirmNewPassword) {
    const res = await fetch(
        `/api/account/password`,
        {
            method: 'PATCH',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ currentPassword, newPassword, confirmNewPassword}),
        }
    );
    // Throw only for unexpected statuses (500 etc)
    if (res.status >= 500) {
        throw new Error(data?.error || `Server error (${res.status})`);
    }

    return { status: res.status, ok: res.ok };
}